import { EntityDescriptor } from '../business-logic';
import { feedbacksSchema } from '../schemas/feedbacks';

export const feedbacksEntity: EntityDescriptor = {
	feedbacks: {
		schema: feedbacksSchema,
		migrationStrategies: {
			1: (oldDoc) => oldDoc,
		},
	},
};
